<script setup lang="ts">
import { ElCard } from 'element-plus'
import { computed, type Component } from 'vue'

interface Props {
  title: string
  icon?: Component
  isLoading?: boolean
  bodyClass?: string
  headerClickable?: boolean
  showHeader?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  title: '',
  isLoading: false,
  bodyClass: '',
  headerClickable: false,
  showHeader: true
})

const emit = defineEmits<{
  'header-click': []
}>()

const IconComponent = computed(() => props.icon)
</script>

<template>
  <ElCard v-loading="props.isLoading" shadow="hover">
    <div class="card-header" @click="props.headerClickable && emit('header-click')"
      :class="{ 'header-clickable': props.headerClickable }" v-if="props.showHeader">
      <div class="header-left">
        <slot name="header-left">
          <el-icon v-if="IconComponent">
            <component :is="IconComponent" />
          </el-icon>
          <span>{{ props.title }}</span>
        </slot>
      </div>
      <div class="header-right">
        <slot name="header-right" />
      </div>
    </div>

    <div :class="props.bodyClass">
      <slot />
    </div>

    <template #footer v-if="$slots.footer">
      <slot name="footer" />
    </template>
  </ElCard>
</template>



